import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { type WebsiteModulePublicSpecsFragment } from '../../../../api/fragments/WebsiteModulePublicSpecs';
import renderMarkdown from '../../../../utilities/renderMarkdown';
import { CompanyContactUs, CompanyConnectContainer, WebpageCompanyContainer } from './shared';
import WebsiteSocialMedia from './WebsiteSocialMedia';

type CompanyDetailsProps = {
    module: WebsiteModulePublicSpecsFragment;
};

const CompanyDetails = ({ module }: CompanyDetailsProps) => {
    const { t } = useTranslation('webpageDetails');

    if (module.socialMedia.length < 1 && !module.address) {
        return null;
    }

    return (
        <WebpageCompanyContainer>
            {module.address ? (
                <CompanyContactUs>
                    <Typography.Text>{renderMarkdown(module.address)}</Typography.Text>
                </CompanyContactUs>
            ) : (
                ''
            )}

            {module.socialMedia.length > 0 && (
                <CompanyConnectContainer>
                    <div>
                        <Typography.Title className="connect-company" level={4}>
                            {t('webpageDetails:company.connectCompany', { company: module.company.displayName })}
                        </Typography.Title>
                        <WebsiteSocialMedia socialMedia={module.socialMedia} />
                    </div>
                </CompanyConnectContainer>
            )}
        </WebpageCompanyContainer>
    );
};

export default CompanyDetails;
